export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      // Use the modern clipboard API
      await navigator.clipboard.writeText(text);
      return true;
    } else {
      // Modern clipboard API not available
      // eslint-disable-next-line no-console
      console.error('Clipboard API not available');
      return false;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to copy to clipboard:', error);
    return false;
  }
}
